import "./Carousel.css";
import React from "react";
import map from "lodash/map";
import noop from "lodash/noop";
import autobind from "autobind-decorator";
import { observer } from "mobx-react";
import { observable } from "mobx";
import className from "classnames";

@observer
class Carousel extends React.Component {
    @observable prevValue;
    @observable nextValue;
    @observable currentValue;

    static defaultProps = {
        timeInterval: false // Default: timer is off
    }

    constructor(props) {
        super(props);
        this.currentValue = this.props.default;
    }

    componentDidMount() {
        if (this.props.timeInterval) {
            this.startTimer();
        }
    }

    @autobind
    startTimer() {
        this.timer = setInterval(() => {
            this.nextSlide();
        }, this.props.timeInterval);
    }

    @autobind
    resetTimer() {
        if (this.props.timeInterval) {
            clearInterval(this.timer);
            this.startTimer();
        }
    }

    @autobind
    nextSlide() {
        this.updateChild((this.currentValue + 1) % this.props.children.length);
    }

    @autobind
    prevSlide() {
        this.updateChild((this.currentValue - 1) < 0 ? this.props.children.length - 1 : this.currentValue - 1);
    }

    @autobind
    updateChild(child) {
        this.prevValue = this.currentValue;
        this.nextValue = child;
        this.resetTimer(); // Resetting the timer to avoid wonky double slide updates
    }

    @autobind
    updateNext() {
        this.currentValue = this.nextValue;
        this.prevValue = -1;
        this.nextValue = -1;
    }

    render() {
        const { children } = this.props;

        return (
            <div className="carousel">
                <div className="carousel-children">
                    {map(children, (child, i) => (
                        <div key={i}
                            className={className("carousel-child",
                                {
                                    selected: this.currentValue === i,
                                    previous: this.prevValue === i
                                }
                            )}
                            onAnimationEnd={this.prevValue === i ? this.updateNext : noop}
                            tabIndex={this.currentValue === i ? 0 : -1}
                        >
                            {child}
                        </div>
                    )
                    )}
                </div>
                <div className="carousel-indicator-arrows">
                    <button
                        className="prev-child"
                        aria-label="Prev Slide"
                        onClick={this.prevSlide}
                    >
                        ‹
                    </button>
                    <button
                        className="next-child"
                        aria-label="Next Slide"
                        onClick={this.nextSlide}
                    >
                        ›
                    </button>
                </div>
                <div className="carousel-indicator-section">
                    {map(children, (child, i) => (
                        <button
                            key={i}
                            className={className("carousel-indicators", { selected: this.currentValue === i })}
                            onClick={() => this.updateChild(i)}
                            name={i}
                            disabled={this.currentValue === i}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default Carousel;